"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseBackendIngredientBreakdown = parseBackendIngredientBreakdown;
exports.parseBackendIngredientServings = parseBackendIngredientServings;
exports.parseCustomerFavoriteMenu = parseCustomerFavoriteMenu;
exports.parseMenu = parseMenu;
exports.parseMenus = parseMenus;
exports.parseNutrientAmounts = void 0;
exports.prepareIngredientServings = prepareIngredientServings;
exports.userOrderMenuItems = userOrderMenuItems;
exports.userOrdersMenuItems = userOrdersMenuItems;
var _lodash = require("lodash");
function parseBackendIngredientServings(backendIngredientServings) {
  return (0, _lodash.chain)(backendIngredientServings).map(ingredient => [ingredient.ingredient, parseFloat(ingredient.serving, 10)]).fromPairs().value();
}
function parseBackendIngredientBreakdown(backendIngredientBreakdown) {
  return (0, _lodash.chain)(backendIngredientBreakdown).map(ingredientBreakdown => ({
    ...ingredientBreakdown,
    price: parseFloat(ingredientBreakdown.price),
    serving: parseFloat(ingredientBreakdown.serving),
    singlePrice: parseFloat(ingredientBreakdown.singlePrice),
    total: parseFloat(ingredientBreakdown.total),
    discountAmount: parseFloat(ingredientBreakdown.discountAmount)
  })).value();
}
function prepareIngredientServings(frontendIngredientServings) {
  const backendIngredientServings = [];
  Object.keys(frontendIngredientServings).forEach(ingdId => backendIngredientServings.push({
    ingredient: ingdId,
    serving: frontendIngredientServings[ingdId]
  }));
  return backendIngredientServings;
}
function parseMenu(menu, menuGroupId) {
  const menuItem = {};
  const menuItemIngredientServings = {};
  const frontendIngredientServings = parseBackendIngredientServings(menu.ingredients);
  menuItemIngredientServings["".concat(menu.id, "_").concat(menuGroupId)] = frontendIngredientServings;
  menuItem["".concat(menu.id, "_").concat(menuGroupId)] = {
    ...menu,
    apiId: menu.id,
    id: "".concat(menu.id, "_").concat(menuGroupId),
    menuGroupId,
    price: parseFloat(menu.price),
    ingredients: undefined,
    ingredientServings: frontendIngredientServings
  };
  return {
    menuItem,
    menuItemIngredientServings
  };
}
function parseCustomerFavoriteMenu(menu) {
  const ingredientServings = parseBackendIngredientServings(menu.ingredients);
  const favoriteMenuItem = {
    ...menu,
    apiId: menu.menu,
    price: null,
    flags: [],
    personalSettings: [menu.personalSettings],
    ingredient: undefined,
    ingredientServings,
    isFavorite: true
  };
  return {
    favoriteMenuItem,
    ingredientServings
  };
}
function userOrderMenuItems(userOrder) {
  let menuItems = {};
  let menuItemIngredientServings = {};
  userOrder.ordermenu.map(userOrderItem => {
    const result = parseMenu(userOrderItem.menu);
    menuItems = {
      ...menuItems,
      ...result.menuItem
    };
    menuItemIngredientServings = {
      ...menuItemIngredientServings,
      ...result.menuItemIngredientServings
    };
    return userOrderItem;
  });
  return {
    menuItems,
    menuItemIngredientServings
  };
}
function userOrdersMenuItems(userOrders, food) {
  let menuItems = {};
  let menuItemIngredientServings = {};
  userOrders.map(userOrder => {
    const result = userOrderMenuItems(userOrder, food);
    menuItems = {
      ...menuItems,
      ...result.menuItems
    };
    menuItemIngredientServings = {
      ...menuItemIngredientServings,
      ...result.menuItemIngredientServings
    };
    return userOrder;
  });
  return {
    menuItems,
    menuItemIngredientServings
  };
}
function parseMenus(menus, menuGroupId) {
  let menuItems = {};
  let menuItemIngredientServings = {};
  const apiIdMenuItemNames = {};
  menus.map(menu => {
    const result = parseMenu(menu, menuGroupId);
    menuItems = {
      ...menuItems,
      ...result.menuItem
    };
    menuItemIngredientServings = {
      ...menuItemIngredientServings,
      ...result.menuItemIngredientServings
    };
    apiIdMenuItemNames[menu.id] = menu.name;
    return menu;
  });
  return {
    apiIdMenuItemNames,
    menuItems,
    menuItemIngredientServings
  };
}
const parseNutrientAmounts = nutrients => (0, _lodash.chain)(nutrients).mapValues(nutrient => nutrient.amount).value();
exports.parseNutrientAmounts = parseNutrientAmounts;